import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerNativeOauthDeepLinkListener } from "@/lib/nativeOauthDeepLink";
import { initLiveUpdates } from "@/lib/liveUpdates";

registerNativeOauthDeepLinkListener();
initLiveUpdates();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
